export const UNIT_TYPE_OPTIONS = [
  { label: "Apartment", value: "APT" },
  { label: "Overground Parking", value: "OVER_PARK" },
  { label: "Underground Parking", value: "UNDER_PARK" },
  { label: "Storage", value: "STO" },
  { label: "Land", value: "LAND" },
  { label: "Sad", value: "SAD" },
];
